export default {
  REGISTER: {
    // REGISTER_PHONE_REGISTER: '/api/ucenter/front/member/third/phoneRegister',
    REGISTER_PHONE_REGISTER: '/api/ucenter/memberLogin/mob/loginMobileSMS',
    REGISTER_SEND_MEMBER: '/api/ucenter/member/mob/sendSmsForMember',
    // 图形验证码
    CAPTCHA: "/api/base/front/img/captchaImage",
    REGISTER_FIND_PAGE: "/api/item/mall/front/market/page/mob/findPage",
    REGISTER_UPLOAD: "/api/item/mall/front/market/page/mob/uploadData",
  }
}
